import reduxFetch from 'react-redux-fetch';
import apiRoutes from '../../../../app/api/routes';
import { createErrorMessage } from '../../../app/helpers/createErrorMessage';

const UpdateNotificationSettingsService = ComposedComponent =>
  reduxFetch([
    {
      resource: 'updateNotificationSettings',
      method: 'put',
      request: (id, body, t) => ({
        url: apiRoutes.notificationSettings(id),
        body,
        meta: {
          toaster: {
            onErrorMessage: createErrorMessage(t, 'updateNotificationSettingsFailed'),
            onSuccessMessage: t('updateNotificationSettingsSuccess'),
          },
        },
      }),
    },
  ])(ComposedComponent);

export default UpdateNotificationSettingsService;
